module.exports = "/images/vendor/flag-icon-css/flags/1x1/cw.svg?69f19c22070d22008ce7c303e82be825";